module.exports = __webpack_public_path__ + "static/ziawbg-485428fd3dbf1dcd94f240db382081ec.png";